// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"df764cc0","496":"3061aff9","498":"8efe1d2c","513":"728b50c2"}[chunkId] + ".chunk.js";
};